/**
Project: Voice Panel (c)
Title: Device Type Table Header Columns  
Description: Settings related to number type list page table column
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import IntlUtil from "../../../../core/helpers/intl-util";
import React from "react";
import {
    AddIcon
} from "@fluentui/react-northstar";

export const DeviceTypeTableHeaderColumns = (intlNamespace) => [
    {
        columnId: "deviceTypeName",
        columnLabel: IntlUtil.getText(intlNamespace, "content.headerDeviceType"),
        isSortable: true,
        cellClassName: "vpa-table-header-cell vpa-table-header-cell-sort",
    },
    {
        columnId: "serialNumberInclude",
        columnLabel: IntlUtil.getText(intlNamespace, "content.headerSerialNumber"),
        isSortable: true,
        cellClassName: "vpa-table-header-cell vpa-table-header-cell-sort",
    },
    {
        columnId: "deviceTypeNotes",
        columnLabel: IntlUtil.getText(intlNamespace, "content.headerNotes"),
        isSortable: true,
        cellClassName: "vpa-table-header-cell vpa-table-header-cell-sort",
    },
    {
        columnId: "actions",
        columnLabel: IntlUtil.getText(intlNamespace, "content.headerActions"),
        isSortable: false,
        cellClassName: "vpa-table-header-cell",
        hasClassName: ['vpa-table-left', 'float-right'],
        hasButton: true,
        buttonIcon: <AddIcon />,
        buttonText: "Add"
    }
]